import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal, WritableSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule, GtmClickDirective } from '@pro-connect/shared';

@Component({
  selector: 'app-expander',
  templateUrl: './expander.component.html',
  styleUrls: ['./expander.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule, GtmClickDirective],
})
export class ExpanderComponent {
  public title = input.required<string>();
  public initialOpen = input<boolean>(false);

  public isOpened: WritableSignal<boolean | null> = signal(null);

  public ngOnInit(): void {
    if (this.initialOpen()) {
      this.isOpened.set(true);
    }
  }
}
